// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gQaA","largestCol":"styles_largestCol__1mv47","smallestCol":"styles_smallestCol__4Tk-C"};